// UI copy shared by the portal and public surveys. Customer content is never translated.
export const portalZH = {
  question_option_label: '问题 {{question}} 的选项 {{option}}',
  surveys: '问卷',
  survey: '问卷',
  listen_to_your_customers_and_assign_tags_after_submission:
    '倾听客户意见，并在提交后添加标签。',
  select_a_venue_to_manage_surveys: '选择门店以管理问卷。',
  create_survey: '创建问卷',
  edit_survey: '编辑问卷',
  search_surveys_by_name: '按名称搜索问卷',
  search_for_a_survey_by_name: '按名称搜索问卷…',
  no_surveys_found: '未找到问卷',
  create_your_first_survey_to_collect_feedback_and_ratings:
    '创建第一份问卷以收集意见和评分。',
  published: '已发布',
  paused_draft: '已暂停／草稿',
  responses: '回复',
  rating: '评分',
  none_yet: '暂无',
  customer_link: '客户链接',
  surveys_2: '份问卷',
  questions: '个问题 ·',
  tags: '标签',
  responses_2: '条回复',
  survey_saved: '问卷已保存',
  save_survey: '保存问卷',
  write_your_questions_a_five_star_rating_is_always_included_at_the_end:
    '编写问题。问卷末尾始终包含五星评分。',
  survey_name: '问卷名称 *',
  e_g_how_was_your_dinner: '例如：您对晚餐满意吗？',
  introduction_for_the_customer: '客户介绍文字',
  tags_to_add_after_submission: '提交后添加的标签',
  these_are_added_to_the_customer_s_tags_without_removing_existing_ones:
    '这些标签会添加到客户资料中，不会删除已有标签。',
  loading_tags: '正在加载标签…',
  select_venue_tags: '选择门店标签',
  question_and_answer_tags_are_not_yet_supported_by_the_connected_service_you_can_confi:
    '当前连接的服务尚不支持问题和答案标签。您可以在此配置，但需更新服务后才能保存。',
  question_and_answer_tags_require_an_update_to_the_connected_service_the_survey_was_no:
    '问题和答案标签需要更新连接的服务。问卷尚未保存。',
  enter_a_name_question_text_and_at_least_two_distinct_options_for_choice_questions:
    '请填写名称、问题内容，并为选择题提供至少两个不同选项。',
  question: '问题',
  question_text: '问题内容 *',
  answer_type: '答案类型',
  text_answer: '开放式回答',
  single_choice_one_answer: '单选 — 一个答案',
  multiple_choice_several_answers: '多选 — 多个答案',
  question_tags: '问题标签',
  added_when_the_customer_answers_this_question: '客户回答此问题时添加。',
  no_tags_for_this_question: '此问题没有标签',
  answer_options_2_to_20: '答案选项（2 至 20 个）',
  tags_when_the_customer_selects_this_answer: '客户选择此答案时添加的标签',
  select_tags_for_this_answer: '选择此答案的标签',
  add_option: '添加选项',
  remove_option: '删除选项',
  required_answer: '必答',
  add_question: '添加问题',
  move_question_up: '上移问题',
  move_question_down: '下移问题',
  remove_question: '删除问题',
  final_rating_from_1_to_5_stars: '最终评分：1 至 5 星',
  the_customer_selects_a_star_rating_before_submitting_the_survey:
    '客户提交问卷前需选择星级评分。',
  publish_survey: '发布问卷',
  when_disabled_links_no_longer_accept_responses_existing_responses_remain_saved:
    '禁用后，链接将不再接受填写。已有回复仍会保留。',
  survey_preview: '问卷预览',
  create_a_customer_link: '创建客户链接',
  search_customers_by_name_email_or_code: '按姓名、邮箱或编号搜索客户',
  type_at_least_2_characters: '请输入至少 2 个字符…',
  searching: '正在搜索…',
  no_customers_found: '未找到客户。',
  generate_customer_link: '生成客户链接',
  this_link_associates_the_response_with_the_selected_customer:
    '此链接将回复关联至所选客户。',
  survey_link: '问卷链接',
  link_copied: '链接已复制',
  copy_the_link_manually_from_the_field_above: '请手动复制上方输入框中的链接。',
  loading_responses: '正在加载回复…',
  you_have_not_received_any_responses_yet: '您尚未收到回复。',
  tags_added: '已添加标签：',
  the_request_could_not_be_completed: '无法完成请求。',
  your_opinion_matters: '您的意见很重要',
  the_link_is_incomplete_ask_the_venue_for_a_new_link:
    '链接不完整。请向门店索取新链接。',
  this_survey_is_unavailable_ask_the_venue_for_a_new_link:
    '此问卷不可用。请向门店索取新链接。',
  we_could_not_load_the_survey_please_try_again: '无法加载问卷，请重试。',
  loading_failed: '加载失败。',
  the_survey_has_been_updated_please_review_the_questions:
    '问卷已更新，请重新检查问题。',
  check_your_answers_and_choose_a_rating_from_1_to_5_stars:
    '请检查答案并选择 1 至 5 星评分。',
  submission_failed_please_try_again_shortly: '提交失败，请稍后重试。',
  submission_failed: '提交失败。',
  your_voice_helps_us_grow: '您的声音助力我们成长',
  a_moment_to_listen: '倾听您的心声',
  your_feedback_makes_a_difference: '您的意见能带来改变。',
  preparing_your_survey: '正在准备您的问卷…',
  responses_sent: '回复已发送',
  thank_you_for_your_feedback: '感谢您的反馈！',
  your_answers_have_been_recorded_thank_you_for_taking_the_time_to_help_us_improve:
    '您的回答已记录。感谢您抽出时间帮助我们改进。',
  tell_us_about_your_experience: '分享您的体验',
  answer_the_questions_and_leave_your_final_rating: '回答问题并给出最终评分。',
  your_answers_are_linked_to_your_customer_profile:
    '您的回答将关联到客户资料。',
  powered_by: '技术支持',
  optional: '（选填）',
  write_your_answer_here: '请在此填写答案…',
  choose_one_answer: '请选择一个答案。',
  you_can_choose_several_answers: '可以选择多个答案。',
  how_would_you_rate_your_experience: '您如何评价此次体验？*',
  choose_from_1_to_5_stars: '请选择 1 至 5 星。',
  no_rating_selected: '未选择评分',
  submit_your_feedback: '提交反馈',
  text_answers_can_contain_up_to_5_000_characters:
    '文字回答最多可包含 5000 个字符。',
  choose_a_valid_answer: '请选择有效答案。',
  choose_only_the_available_options: '请仅选择提供的选项。',
  choose_a_rating_from_1_to_5_stars: '请选择 1 至 5 星评分。',
  complete_the_question_value: '请完成问题：{{question}}',
  value_out_of_5_stars: '{{count}} 星（满分 5 星）',
  value_stars: '{{count}} 星',
  value_questions_value_tags: '{{count}} 个问题 · {{tags}} 个标签',
  value_responses: '{{count}} 条回复',
  value_surveys: '{{count}} 份问卷',
  value_questions_rating: '{{count}} 个问题及评分',
  responses_value: '回复 · {{name}}',
};
